const ColorSelector = ({ colors, t, selectedColorId, setSelectedColorId }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-900">{t("color")}</h3>

      <fieldset aria-label="Choose a color" className="mt-2">
        <div className="flex items-center gap-x-3">
          {colors.map((color) => (
            <label key={color.color_id} className="relative flex items-center justify-center cursor-pointer">
              <input type="radio" name="color" value={color.color_id} checked={selectedColorId === color.color_id} onChange={() => setSelectedColorId(color.color_id)} aria-label={color.name} className="sr-only" />
              <span style={{ backgroundColor: color.hex }} className={`size-12 rounded-full border border-gray-300 ${selectedColorId === color.color_id ? "ring-2 ring-offset-2 ring-black/40" : ""}`} />
            </label>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default ColorSelector;
